import { TemplateResult } from 'lit';
import { unsafeStatic, html } from 'lit/static-html.js';

import type {
  PurchasesAndSalesArgs,
  PurchasesAndSalesItem,
  PurchasesAndSalesItemWithoutRank,
  PurchasesAndSalesItemWithRank,
} from './purchases-and-sales.model.js';
import { Constants } from './purchases-and-sales.constants.js';
import { isNullish } from '../../common/utils/nullish.js';

export const generateHTML = (
  args: PurchasesAndSalesArgs,
): TemplateResult => html`
  <${unsafeStatic(Constants.TAG_NAME)}
    data-product-code="${args.productCode}"
    data-audience="${args.audience}"
    data-country="${args.country}"
    data-language="${args.language}"
    data-component-object="${JSON.stringify(args?.componentObject)}"
  ></${unsafeStatic(Constants.TAG_NAME)}>
`;

export function removeRankFromItem(
  item: PurchasesAndSalesItem,
): PurchasesAndSalesItemWithoutRank {
  // Use destructuring to extract everything except the rank

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { rank, ...rest } = item;
  return rest;
}

export function isItemWithRank(
  item: PurchasesAndSalesItem,
): item is PurchasesAndSalesItemWithRank {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const rank = (item as PurchasesAndSalesItemWithRank).rank;
  return !isNullish(rank) && typeof rank === 'number';
}
